export var EnteredEditModeEvent = 'EnteredEditMode';
export var ExitedEditModeEvent = 'ExitedEditMode';
export var PreviewLoadEvent = 'PreviewLoad';
export var PreviewErrorEvent = 'PreviewError';
export var PreviewLoadOrErrorEvent = 'PreviewLoadOrError';
export var CloseEvent = 'Close';
export var AnimationEndEvent = 'AnimationEnd';
//# sourceMappingURL=eventNames.js.map